const angular = require('angular');
const ngMessages = require('angular-messages');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');

const walletModuleName = 'wowApp.wallet';

const DigitalPayPaymentInstrumentsService = require('./digital-pay-payment-instruments.service');
const DigitalPayIframeEventHandler = require('./digital-pay-iframe.eventHandler');

angular.module(walletModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular'])
    .service('DigitalPayPaymentInstrumentsService', ['$q', 'Restangular', DigitalPayPaymentInstrumentsService])
    .service('DigitalPayIframeEventHandler', ['$window', DigitalPayIframeEventHandler]);

require('./common');
require('./creditcard');
require('./error');
require('./giftcard');
require('./paypal');

module.exports = walletModuleName;



// WEBPACK FOOTER //
// ./src/wallet/wallet.module.js